import { AuthenticatedDataRequest } from '@eggplant/data-request'
import { MODELER_SERVICE } from '@eggplant/api-hosts'
import { useGetParamsWithSpaceId } from '../useGetParamsWithSpaceId'
import type {
  Error,
  Requirement,
  RequirementQueryParams
} from '@eggplant/types'
import type { ReactElement } from 'react'

interface Props {
  params?: RequirementQueryParams
  shortErrorMessage?: string
  onError?: (error: Error) => void
  onSuccess?: (response: Requirement[]) => void
  children?: (response: Requirement[]) => ReactElement
}

const GetRequirementNamesRequest = ({
  params,
  shortErrorMessage,
  onError,
  onSuccess,
  children
}: Props) => {
  const url = `${MODELER_SERVICE}/requirement_names`

  const { requestParams } = useGetParamsWithSpaceId<RequirementQueryParams | undefined>(params)

  return (
    <AuthenticatedDataRequest
      children={children}
      method='get'
      onError={onError}
      onSuccess={onSuccess}
      params={requestParams}
      shortErrorMessage={shortErrorMessage}
      url={url}
    />
  )
}

export default GetRequirementNamesRequest
